import React, { useEffect } from "react";
import Select from "react-select";
import { Search } from "../../icons";

const ProductsFilter = (props) => {
    const [defaultOption, setDefaultOption] = React.useState(null);

    const options = [
        {
            value: '',
            label: 'Category'
        },
      ...props.category?.map(el => ({
          value: el?.toLowerCase().trim().split(' ').join('-'),
          label: el
      })) || []
    ]

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const category = queryParams.get("category");

        if (category !== '' && category !== null && category) {
            setDefaultOption({
                value: category?.toLowerCase().trim().split(' ').join('-'),
                label: category
            });
            props.onClick(category?.toLowerCase().trim().split(' ').join('-'));
        } else {
            setDefaultOption('');
        }
    }, []);

    return (
        <div className={`products-filter ${props.theme}`} data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            <div className="products-filter__bar">
                <Select
                    options={options}
                    id='category'
                    name='category'
                    placeholder='Category'
                    classNamePrefix='react-select'
                    className='react-select'
                    isSearchable={false}
                    onChange={(selectedOption) => {
                        props.onClick(selectedOption.value)
                        setDefaultOption(selectedOption)
                    }}
                    value={defaultOption && options.find(x => x.value === defaultOption?.value)}
                />
            </div>
            <div className='products-filter__input'>
                <input onChange={(e) => props.onInput(e.target.value)} placeholder='or Search' type="text"/>
                <Search/>
            </div>
        </div>
    )
}

ProductsFilter.defaultProps = {
    category: [],
    defaultOption: '',
    onClick: () => {},
    onInput: () => {}
};

export default ProductsFilter;
